/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */


import React, { Component } from 'react';
import { Card, CardDeck, CardBody, Col, Button } from 'reactstrap';
import { PDFDownloadLink, Document, Page, Text, StyleSheet, View, Link } from '@react-pdf/renderer';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import axios from 'axios';
import { connect } from 'react-redux';
import { countryList } from '../../../../../helpers/shipping/Countries';
import SubmitBatchButton from './SubmitBatchButton';
import { domesticServices, internationalServices } from '../../../../../helpers/shipping/AbdServices';
import { getServicePrice, getMMServicePrice, isTaxable, getShippingZone, getAvailableTrackedService } from '../../../../../helpers/shipping/AbdPricer';

const currencyFormat = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
const URL = 'https://api.musicmarquee.co.uk';

let MyDoc;

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
  },
  section: {
    margin: 10,
    padding: 0,
    borderBottomStyle: 'solid',
    borderBottomColor: 'black',
    borderBottomWidth: 1,
  },
  multipleSplitSection: {
    padding: 0,
    borderBottomStyle: 'solid',
    borderBottomColor: 'black',
    borderBottomWidth: 4,
  },
  header: {
    fontSize: 18,
    textAlign: 'center',
    // color: 'red',
  },
  subHeader: {
    fontSize: 14,
    textAlign: 'center',
    // color: 'red',

  },
  subSubHeader: {
    fontSize: 12,
    textAlign: 'center',
    // color: 'red',

  },
  text: {
    fontSize: 14,
    // color: 'red',
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    margin: 5,
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
  },
  tableCol: {
    width: '25%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCell: {
    margin: 'auto',
    marginTop: 5,
    fontSize: 10,
    // color: 'red',
  },
  multipleHeaderCell: {
    margin: 'auto',
    marginTop: 5,
    fontSize: 10,
    // color: 'red',
  },
});

const getColumnWidth = (rows, accessor, headerText) => {
  if (rows !== undefined) {
    const maxWidth = 400;
    let magicSpacing = 10;
    switch (accessor) {
      case 'total':
        magicSpacing += 3;
        break;
      case 'seller_id':
        magicSpacing += 10;
        break;
      case 'pull_sheet':
        magicSpacing += 5;
        break;
      default:
    }
    const cellLength = Math.max(
      ...rows.map(row => (`${row[accessor]}` || '').length),
      headerText.length,
    );
    return Math.min(maxWidth, cellLength * magicSpacing);
  }
  return null;
};

// const currencyFormat = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' })

class OpenOrdersTable extends Component {
  constructor() {
    super();
    this.state = {
      pages: 2,
      loading: false,
      groupedData: [],
      data: [],
      selectedGroup: undefined,
      selected: undefined,
      selectedActWeight: null,
      selectedActualPrice: null,
      selectedMMPrice: null,
      shipmentBatch: [],
      isEditing: false,
      // selectedSize: null,
    };
    this.getGroupedOrders();
  }

  async getGroupedOrders() {
    const response = await axios.post(`${URL}/admin/aboveboard/orders/bandcamp/open`, {
      page: 1,
      pageSize: 1000,
      sorted: null,
      filtered: null,
    }, { headers: { Authorization: localStorage.getItem('mm_admin') } });

    const grouped = response.data.orders.filter(orderDest => orderDest.ship_to_country_code === 'GB').reduce((groups, order) => {
    // const grouped = response.data.orders.reduce((groups, order) => {
      if (response.data.orders.filter(filterOrder => filterOrder.payment_id === order.payment_id).length > 1) {
        const hasPreOrder = response.data.orders.filter(filterOrder => filterOrder.payment_id === order.payment_id).filter(filterOrder2 => filterOrder2.is_preorder === true).length > 0;
        const outOfStock = response.data.orders.filter(filterOrder => filterOrder.payment_id === order.payment_id).filter(filterOrder2 => filterOrder2.mm_quantity < 1).length > 0;
        order.is_preorder = hasPreOrder;
        if (hasPreOrder) {
          if (!groups['Multiple Items (Pre-Order)']) groups['Multiple Items (Pre-Order)'] = [];
          groups['Multiple Items (Pre-Order)'].push(order);
        } else if (outOfStock) {
          if (!groups['Multiple Items (Out of Stock)']) groups['Multiple Items (Out of Stock)'] = [];
          groups['Multiple Items (Out of Stock)'].push(order);
        } else {
          if (!groups['Multiple Items']) groups['Multiple Items'] = [];
          groups['Multiple Items'].push(order);
        }
        // groups['Multiple Items'].push(response.data.orders.find(filterOrder =>
        //   filterOrder.payment_id === order.payment_id));
      } else {
        const title = `${order.album_title ? `${order.album_title}:` : ''} ${order.title} by ${order.artist}`;
        if (!groups[title]) groups[title] = [];
        groups[title].push(order);
      }
      return groups;
    }, {});

    const group2 = [];
    Object.keys(grouped).forEach((key) => {
      let orderType = '';
      if (grouped[key].filter(filterOrder => filterOrder.is_preorder === true).length > 0) {
        orderType = 'Pre-Order';
      } else if (grouped[key].filter(filterOrder => filterOrder.mm_quantity < 1).length > 0) {
        orderType = 'Out of Stock';
      } else {
        orderType = 'Ready';
      }
      const obj = {
        item: key,
        orders: grouped[key],
        orderType,
      };
      group2.push(obj);
    });
    this.setState({
      groupedData: group2,
    });
  }

  async submitPrepareBatch(group) {
    if (group.item === 'Multiple Items' || group.item === 'Multiple Items (Pre-Order)') {
      const orders = [];
      const grouped = group.orders.reduce((groups, order) => {
        if (group.orders.filter(filterOrder => filterOrder.payment_id === order.payment_id).length > 1) {
          if (!groups[order.payment_id]) groups[order.payment_id] = [];
          groups[order.payment_id].push(order);
        }
        return groups;
      }, {});

      Object.keys(grouped).forEach((key) => {
        orders.push(grouped[key]);
      });

      const ordersToPush = [];

      orders.map((groupOrders) => {
        let service = '';
        let mmSize = 'SP';
        let toTrack = false;
        groupOrders.map((groupOrder) => {
          if (groupOrder.sku === 'VRADE19') {
            toTrack = true;
          }
          if (groupOrders[0].package_size === 'LL' && groupOrder.package_size === 'SP') {
            groupOrders[0].package_size = 'SP';
          }
        });
        if (groupOrders[0].ship_to_country_code === 'GB') {
          service = 'CRL48';
          if (toTrack) {
            service = 'CRL24S';
          }
        } else if (groupOrders[0].ship_to_country_code !== 'GB') {
          if (groupOrders[0].package_size === 'SP') {
            service = 'IE1';
            mmSize = 'SP';
          } else if (groupOrders[0].package_size === 'LL') {
            service = 'IG1';
            mmSize = 'LL';
          }
          if (toTrack) {
            service = getAvailableTrackedService(groupOrders[0].ship_to_country, groupOrders[0].package_size);
          }
        }
        // console.log(service);
        // console.log(groupOrders[0].ship_to_country);
        // console.log(toTrack);
        // console.log();
        groupOrders[0].shipping_service = service;
        groupOrders[0].mm_package_size = mmSize;
        let totalValue = 0.00;
        groupOrders.map((order) => {
          totalValue += parseFloat(order.sub_total);
        });
        ordersToPush.push({
          payment_id: groupOrders[0].payment_id,
          sub_total: totalValue,
          shipping_service: service,
          mm_package_size: mmSize,
          package_size: groupOrders[0].package_size,
        });
      });
      const group2 = {};
      group2.orders = ordersToPush;
      await axios.post(`${URL}/admin/aboveboard/orders/bandcamp/prepare`, {
        group2,
      }, { headers: { Authorization: localStorage.getItem('mm_admin') } })
        .then((res) => {
        // Update react-table
          const groupCopy = this.state.selectedGroup;
          res.data.orders.map((resOrder) => {
            const groupOrders = groupCopy.orders.filter(findOrder =>
              findOrder.payment_id.toString() === resOrder.payment_id.toString());
            groupOrders.map((groupOrder) => {
              groupOrder.fulfilment_status = resOrder.status;
              groupOrder.fulfilment_id = resOrder.id;
              groupOrder.shipping_service = resOrder.shipping_service;
              groupOrder.package_size = resOrder.package_size;
            });
          });
          this.setState({ selectedGroup: groupCopy });
        });
    } else {
      const orders = [];

      group.orders.map((order) => {
        let service = '';
        let mmSize = 'SP';
        if (order.ship_to_country_code === 'GB') {
          service = 'CRL48';
          if (order.sku === 'VRADE19') {
            service = 'CRL24S';
          }
        } else if (order.ship_to_country_code !== 'GB') {
          if (order.package_size === 'SP') {
            service = 'IE1';
            mmSize = 'SP';
          } else if (order.package_size === 'LL') {
            service = 'IG1';
            mmSize = 'LL';
          }
          if (order.sku === 'VRADE19') {
            service = getAvailableTrackedService(order.ship_to_country, order.package_size);
          }
        }
        order.shipping_service = service;
        order.mm_package_size = mmSize;

        orders.push({
          payment_id: order.payment_id,
          package_id: order.package_id,
          sub_total: order.sub_total,
          shipping_service: service,
          mm_package_size: mmSize,
          package_size: order.package_size,
        });
      });
      const group2 = {};
      group2.orders = orders;
      await axios.post(`${URL}/admin/aboveboard/orders/bandcamp/prepare`, {
        group2,
      }, { headers: { Authorization: localStorage.getItem('mm_admin') } })
        .then((res) => {
        // Update react-table
          const groupCopy = this.state.selectedGroup;
          res.data.orders.map((resOrder) => {
            const groupOrder = groupCopy.orders.find(findOrder =>
              findOrder.payment_id.toString() === resOrder.payment_id.toString());
            groupOrder.fulfilment_status = resOrder.status;
            groupOrder.fulfilment_id = resOrder.id;
            groupOrder.shipping_service = resOrder.shipping_service;
            groupOrder.package_size = resOrder.package_size;
          });
          this.setState({ selectedGroup: groupCopy });
        });
    }
    return true;
  }

  async submitShipmentBatch(row) {
    const smallPackage = 50;
    const mediumPackage = 110;
    const largePackage = 180;

    if (row.item === 'Multiple Items' || row.item === 'Multiple Items (Pre-Order)') {
      const orders = [];
      const grouped = row.orders.reduce((groups, order) => {
        if (row.orders.filter(filterOrder => filterOrder.payment_id === order.payment_id && filterOrder.fulfilment_status === 'Preparing').length > 1) {
          if (!groups[order.payment_id]) groups[order.payment_id] = [];
          groups[order.payment_id].push(order);
        }
        return groups;
      }, {});

      Object.keys(grouped).forEach((key) => {
        orders.push(grouped[key]);
      });

      const filteredOrders = [];
      const itemsForUpdate = [];
      orders.map((groupOrders) => {
        if (groupOrders[0].fulfilment_status === 'Preparing' && filteredOrders.length <= 35) {
          groupOrders[0].packaging_fee = 0.30;
          groupOrders[0].order_fee = 1.00;

          let totalWeight = groupOrders.map(order => order.mm_weight * order.quantity).reduce((prev, curr) => prev + curr, 0);
          groupOrders[0].customsItems = [];

          groupOrders.map((order) => {
            const customsItem = {};
            const nameCheck = order.item_name.toString().toLowerCase();

            if (nameCheck.includes('cd')) {
              customsItem.itemDesc = 'CD';
              customsItem.itemHs = 8523492000;
            } else if (nameCheck.includes('poster')) {
              customsItem.itemDesc = 'Poster';
              customsItem.itemHs = 4901990000;
            } else if (nameCheck.includes('cassette')) {
              customsItem.itemDesc = 'Cassette Tape';
              customsItem.itemHs = 8523291900;
            } else if (nameCheck.includes('tee')) {
              customsItem.itemDesc = 'T-Shirt';
              customsItem.itemHs = 6109100010;
            } else if (nameCheck.includes('sweatshirt')) {
              customsItem.itemDesc = 'Sweatshirt';
              customsItem.itemHs = 6109100010;
            } else {
              customsItem.itemDesc = 'Vinyl Record';
              customsItem.itemHs = 8523809000;
            }
            customsItem.itemName = order.item_name;
            customsItem.itemOrigin = 'GBR';
            customsItem.itemQty = order.quantity;
            customsItem.itemPrice = order.price;
            customsItem.itemWeight = order.mm_weight;
            groupOrders[0].customsItems.push(customsItem);
          });
          if (groupOrders[0].package_size === 'SP') {
            if (groupOrders.map(orderCount => orderCount.quantity).reduce((prev, curr) => prev + curr, 0) > 3) {
              totalWeight += largePackage;
              groupOrders[0].packaging_fee = 0.60;
            } else {
              totalWeight += mediumPackage;
            }
          } else {
            totalWeight += smallPackage;
          }
          if (totalWeight > 1999 && groupOrders[0].ship_to_country_code === 'GB') {
            groupOrders[0].shipping_service = 'TPS48';
          }
          // if (totalWeight > 1999 && groupOrders[0].ship_to_country_code !== 'GB') {
          //   totalWeight = 1999;
          // }
          groupOrders[0].mm_weight = totalWeight;
          if (totalWeight > 749) {
            groupOrders[0].packaging_fee = 0.60;
            groupOrders[0].mm_package_size = 'SP';
          }
          const servicePrice = getServicePrice(groupOrders[0].mm_weight, groupOrders[0].shipping_service, groupOrders[0].ship_to_country, groupOrders[0].package_size);
          const mmPrice = getMMServicePrice(groupOrders[0].mm_weight, groupOrders[0].shipping_service, groupOrders[0].ship_to_country, groupOrders[0].mm_package_size);
          const shippingZone = getShippingZone(groupOrders[0].ship_to_country);
          groupOrders[0].shipping_zone = shippingZone;
          groupOrders[0].mm_shipping_cost = mmPrice;
          groupOrders[0].abd_shipping_price = servicePrice;
          groupOrders[0].fee_vat = (groupOrders[0].packaging_fee + groupOrders[0].order_fee) * 0.2;
          if (isTaxable(groupOrders[0].ship_to_country)) {
            groupOrders[0].shipping_vat = groupOrders[0].abd_shipping_price * 0.2;
          } else {
            groupOrders[0].shipping_vat = 0;
          }
          const country = countryList.find(ctry => ctry.label === groupOrders[0].ship_to_country);
          groupOrders[0].ship_to_countrycode = country.value;
          if (groupOrders[0].mm_weight > 1999) {
            if (groupOrders[0].ship_to_country_code === 'GB') {
              filteredOrders.push(groupOrders[0]);
              groupOrders.map((groupOrder) => {
                if (!itemsForUpdate.some(item => item.package_id === groupOrder.package_id)) itemsForUpdate.push({ package_id: groupOrder.package_id, sku: groupOrder.sku, qty: 0 });
                itemsForUpdate.find(item => item.package_id === groupOrder.package_id).qty += groupOrder.quantity;
              });
            }
          } else {
            filteredOrders.push(groupOrders[0]);
            groupOrders.map((groupOrder) => {
              if (!itemsForUpdate.some(item => item.package_id === groupOrder.package_id)) itemsForUpdate.push({ package_id: groupOrder.package_id, sku: groupOrder.sku, qty: 0 });
              itemsForUpdate.find(item => item.package_id === groupOrder.package_id).qty += groupOrder.quantity;
            });
          }
        }
      });
      await axios.post(`${URL}/admin/aboveboard/orders/bandcamp/ship`, {
        orders: filteredOrders,
        items_to_update: itemsForUpdate,
      }, { headers: { Authorization: localStorage.getItem('mm_admin') } })
        .then((res) => {
        // Update react-table
          this.getGroupedOrders();
        });
    } else {
      const filteredOrders = row.orders.filter((order, index) => order.fulfilment_status === 'Preparing' && index <= 35);
      const itemsForUpdate = [];
      // console.log(itemsForUpdate);
      filteredOrders.map((order) => {
        order.packaging_fee = 0.30;
        order.order_fee = 1.00;

        let totalWeight = order.mm_weight * order.quantity;
        if (order.package_size === 'SP') {
          if (order.quantity > 2) {
            totalWeight += largePackage;
            order.packaging_fee = 0.60;
          } else {
            totalWeight += mediumPackage;
          }
        } else {
          totalWeight += smallPackage;
        }
        if (totalWeight > 1999 && order.ship_to_country_code === 'GB') {
          order.shipping_service = 'TPS48';
        }
        order.mm_weight = totalWeight;
        if (totalWeight > 749) {
          order.packaging_fee = 0.60;
          order.mm_package_size = 'SP';
        }
        const servicePrice = getServicePrice(order.mm_weight, order.shipping_service, order.ship_to_country, order.package_size);
        const mmPrice = getMMServicePrice(order.mm_weight, order.shipping_service, order.ship_to_country, order.mm_package_size);
        const shippingZone = getShippingZone(order.ship_to_country);

        order.shipping_zone = shippingZone;
        order.mm_shipping_cost = mmPrice;
        order.abd_shipping_price = servicePrice;
        order.fee_vat = (order.packaging_fee + order.order_fee) * 0.2;
        if (isTaxable(order.ship_to_country)) {
          order.shipping_vat = order.abd_shipping_price * 0.2;
        } else {
          order.shipping_vat = 0;
        }
        const country = countryList.find(ctry => ctry.label === order.ship_to_country);
        order.ship_to_countrycode = country.value;
        order.customsItems = [];

        const customsItem = {};
        customsItem.itemName = order.item_name;

        const nameCheck = order.item_name.toString().toLowerCase();
        if (nameCheck.includes('cd')) {
          customsItem.itemDesc = 'CD';
          customsItem.itemHs = 8523492000;
        } else if (nameCheck.includes('poster')) {
          customsItem.itemDesc = 'Poster';
          customsItem.itemHs = 4901990000;
        } else if (nameCheck.includes('cassette')) {
          customsItem.itemDesc = 'Cassette Tape';
          customsItem.itemHs = 8523291900;
        } else if (nameCheck.includes('shirt ')) {
          customsItem.itemDesc = 'T-Shirt';
          customsItem.itemHs = 6109100010;
        } else if (nameCheck.includes('tee ')) {
          customsItem.itemDesc = 'T-Shirt';
          customsItem.itemHs = 6109100010;
        } else if (nameCheck.includes('sweatshirt')) {
          customsItem.itemDesc = 'Sweatshirt';
          customsItem.itemHs = 6109100010;
        } else {
          customsItem.itemDesc = 'Vinyl Record';
          customsItem.itemHs = 8523809000;
        }
        customsItem.itemOrigin = 'GBR';
        customsItem.itemQty = order.quantity;
        customsItem.itemPrice = 15.00 / order.quantity;
        customsItem.itemWeight = order.mm_weight;
        order.customsItems.push(customsItem);
      });
      const finalFilteredOrders = filteredOrders.filter((order, index) => !(order.ship_to_country_code !== 'GB' && order.mm_weight > 1999));
      finalFilteredOrders.map((groupOrder) => {
        if (!itemsForUpdate.some(item => item.package_id === groupOrder.package_id)) itemsForUpdate.push({ package_id: groupOrder.package_id, sku: groupOrder.sku, qty: 0 });
        itemsForUpdate.find(item => item.package_id === groupOrder.package_id).qty += groupOrder.quantity;
      });
      await axios.post(`${URL}/admin/aboveboard/orders/bandcamp/ship`, {
        orders: filteredOrders,
        items_to_update: itemsForUpdate,
      }, { headers: { Authorization: localStorage.getItem('mm_admin') } })
        .then((res) => {
        // Update react-table
          this.getGroupedOrders();
        });
    }
    return true;
  }

  cancelFulfilment(order) {
    console.log('Cancelling');
    console.log(order.fulfilment_id);
    if (order.fulfilment_id !== undefined) {
      const postData = {
        orderId: order.fulfilment_id,
      };
      axios.post(`${URL}/admin/aboveboard/orders/fulfilment/cancel`, postData, { headers: { Authorization: localStorage.getItem('mm_admin') } })
        .then((response) => {
          const groupCopy = this.state.selectedGroup;
          const groupOrders = groupCopy.orders.filter(findOrder =>
            findOrder.fulfilment_id === response.data.id);
          groupOrders.map((groupOrder) => {
            groupOrder.fulfilment_status = undefined;
            groupOrder.fulfilment_id = undefined;
          });
          this.setState({ selectedGroup: groupCopy });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }


  generateAllOrderPDFs = () => {
    const pullSheet = this.state.groupedData.map(group => (
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.header}>
            AboveBoard PullSheet
          </Text>
          <Text style={styles.subHeader}>
            {new Date().toLocaleDateString()} {new Date().toLocaleTimeString()}
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={styles.subHeader}>
            {group.item}
          </Text>
          <Text style={styles.subHeader}>
            Number of copies to pull: {group.orders.map(order => order.quantity).reduce((prev, curr) => prev + curr, 0)}
          </Text>
        </View>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Customer</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Quantity</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Country</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Initials</Text>
            </View>
          </View>
          {group.orders.map(order => (
            <View style={styles.tableRow}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{order.ship_to_name}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{order.quantity}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{order.ship_to_country}</Text>
              </View>
              <View style={styles.tableCol} />
            </View>
          ))}
        </View>
      </Page>
    ));

    MyDoc = null;

    this.state.groupedData.map((group) => {
      this.setState({ selectedGroup: group });
      this.submitPrepareBatch(group);
    });

    MyDoc = (
      <Document title="Order">
        {pullSheet}
      </Document>
    );

    // const ordersToPrepare = [];
    // orders.map((order) => {
    //   ordersToPrepare.push(order.id);
    // });

    // this.submitPrepareBatch(orders);
    // this.forceUpdate();
  }

  generateOrderPDF = (group) => {
    const clientName = group.clientName || group.orders[0].clientName || group.orders[0].client_name || '';
    if (group.item === 'Multiple Items' || group.item === 'Multiple Items (Pre-Order)') {
      const orders = [];
      const grouped = group.orders.reduce((groups, order) => {
        if (group.orders.filter(filterOrder => filterOrder.payment_id === order.payment_id).length > 1) {
          if (!groups[order.payment_id]) groups[order.payment_id] = [];
          groups[order.payment_id].push(order);
        }
        return groups;
      }, {});

      Object.keys(grouped).forEach((key) => {
        orders.push(grouped[key]);
      });
      // const hasOptions = (!!group.orders[0].options);
      // console.log(group.orders[0].options);
      const pullSheet = (
        <View style={{ width: '100%' }}>
          <View style={styles.section}>
            <Text style={styles.header}>
              AboveBoard PullSheet
            </Text>
            <Text style={styles.subHeader}>
              {new Date().toLocaleDateString()} {new Date().toLocaleTimeString()}
            </Text>
          </View>
          <View style={styles.section}>
            <Text style={styles.subHeader}>
              Multiple Item Orders
            </Text>
          </View>
          {orders.map(order => (
            <View>
              <View style={styles.multipleSplitSection} />
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Customer</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Total Quantity</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell} />
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Country</Text>
                  </View>
                </View>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{order[0].ship_to_name}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{order.map(orderCount => orderCount.quantity).reduce((prev, curr) => prev + curr, 0)}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{order[0].option_name}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{order[0].ship_to_country}</Text>
                  </View>
                </View>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Item</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Quantity</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Option</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>SKU</Text>
                  </View>
                </View>
                {order.map(order2 => (
                  <View style={styles.tableRow}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>{order2.item_name}</Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>{order2.quantity}</Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>{order2.option_name}</Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        {clientName ? `${clientName}\n` : ''}{order2.sku}{'\n'}{order2.mm_location}
                      </Text>
                    </View>
                  </View>
              ))}
              </View>
            </View>
        ))}
        </View>
      );

      MyDoc = null;

      MyDoc = (
        <Document title="Order">
          <Page size="A4" style={styles.page}>
            {pullSheet}
          </Page>
        </Document>
      );
      this.submitPrepareBatch(group);
      this.forceUpdate();
    } else {
      const hasOptions = Array.isArray(group.orders[0].options) && group.orders[0].options.length > 0;
      const pullSheet = (
        <View style={{ width: '100%' }}>
          <View style={styles.section}>
            <Text style={styles.header}>
              AboveBoard PullSheet
            </Text>
            <Text style={styles.subHeader}>
              {new Date().toLocaleDateString()} {new Date().toLocaleTimeString()}
            </Text>
          </View>
          <View style={[styles.section, { width: '100%' }]}>
            <Text style={styles.subHeader}>
              {group.item}
            </Text>
            {clientName ? <Text style={styles.tableCell}>{clientName}</Text> : null}
            {hasOptions ?
              group.orders[0].options.map(option => (
                <Text style={styles.tableCell}>
                  {option.title}: {group.orders.filter(order => order.option_name === option.title)
                    .map(order => order.quantity).reduce((prev, curr) => prev + curr, 0)}
                  {' '}(sku: {option.sku ||
                    (group.orders.find(order => order.option_name === option.title) || group.orders[0]).sku})
                </Text>
              )) : <Text style={styles.tableCell}>SKU: {group.orders[0].sku}{'\n'}{group.orders[0].mm_location}</Text> }
            <Text style={styles.subHeader}>
              Number of items to pull: {group.orders.map(order => order.quantity).reduce((prev, curr) => prev + curr, 0)}
            </Text>
          </View>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Customer</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Quantity</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Option</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Country</Text>
              </View>
            </View>
            {group.orders.map(order => (
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{order.ship_to_name}</Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{order.quantity}</Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{order.option_name}</Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{order.ship_to_country}</Text>
                </View>
              </View>
          ))}
          </View>
        </View>
      );

      MyDoc = null;

      MyDoc = (
        <Document title="Order">
          <Page size="A4" style={styles.page}>
            {pullSheet}
          </Page>
        </Document>
      );

      this.submitPrepareBatch(group);
      this.forceUpdate();
    }
  }

  render() {
    const ordersColumns = [
      {
        Header: 'In Batch?',
        width: getColumnWidth(this.state.data, '', 'In Batch?'),
        getProps: (state, row) => {
          if (row) {
            return {
              style: {
                background: this.state.shipmentBatch.find(shipment => shipment.fulfillmentId === row.original.id) ?
                  'green' : null,
              },
            };
          }
          return {
            style: { className: '-striped -highlight' },
          };
        },
      }, {
        Header: 'FF Id',
        id: 'id',
        sortable: false,
        accessor: 'id',
        width: getColumnWidth(this.state.data, 'id', 'FF Id'),
      }, {
        Header: 'Order Date',
        id: 'order_date',
        filterable: false,
        width: getColumnWidth(this.state.data, 'order_date', 'Order Date'),
        Cell: row => (
          <div>
            <span>{new Date(row.original.order_date).toLocaleDateString()}</span>
          </div>
        ),
      }, {
        Header: 'Customer',
        id: 'ship_to_name',
        sortable: false,
        accessor: 'ship_to_name',
        width: getColumnWidth(this.state.data, 'ship_to_name', 'Customer'),
      }, {
        Header: 'Destination',
        id: 'ship_to_country',
        accessor: 'ship_to_country',
        width: getColumnWidth(this.state.data, 'ship_to_country', 'Destination'),

      }, {
        Header: 'Quantity',
        id: 'quantity',
        accessor: 'quantity',
        width: getColumnWidth(this.state.data, 'quantity', 'Quantity'),

      }, {
        Header: 'Payment State',
        id: 'payment_state',
        accessor: 'payment_state',
        width: getColumnWidth(this.state.data, 'payment_state', 'Payment State'),

      }, {
        Header: 'Fulfilment Status',
        id: 'fulfilment_status',
        width: getColumnWidth(this.state.data, 'fulfilment_status', 'Fulfilment Status'),
        Cell: row => (
          <div>
            {row.original.fulfilment_status === 'Preparing' ? (
              <tr>{row.original.fulfilment_status} (<a href="#" onClick={() => { this.cancelFulfilment(row.original); }}>Remove</a>)</tr>
                          ) : null }
          </div>
        ),

      },
    ];

    const groupedColumns = [
      {
        Header: 'Order Type',
        id: 'order_type',
        width: getColumnWidth(this.state.data, 'order_type', 'Order Type'),
        accessor: d => d.orderType,
        Filter: ({ filter, onChange }) =>
          (
            <select
              onChange={event => onChange(event.target.value)}
              style={{ width: '100%' }}
              value={filter ? filter.value : 'Ready'}
            >
              <option value="Ready">Ready</option>
              <option value="Pre-Order">Pre-Order</option>
              <option value="Out of Stock">Out of Stock</option>
              <option value="">All</option>
            </select>),
      }, {
        Header: 'Item',
        id: 'item',
        sortable: false,
        Cell: row => (
          <div>
            <span>{row.original.item}</span>
            <br />
            <span>{row.original.item === 'Multiple Items' ? '-' : row.original.orders[0].sku}</span>
            <br />
            <span>
              <b>{(row.original.orders.length > 1) ? `${row.original.orders.length} Orders `
              : `${row.original.orders.length} Order `}
               ({row.original.orders.map(order => order.quantity).reduce((prev, curr) => prev + curr, 0)} Items)
              </b>
              {row.original.orderType === 'Pre-Order' ? (
                <div>
                  <span>Release Date: {new Date(row.original.orders[0].release_date).toLocaleDateString()}</span>
                </div>
              ) : null }
            </span>
          </div>
        ),
      }, {
        Header: 'Pull Sheet',
        id: 'pull_sheet',
        sortable: false,
        width: getColumnWidth(this.state.data, 'pull_sheet', 'Pull Sheet'),
        Cell: row => (
          <div>
            {(row.original.orders.filter(filterOrder => filterOrder.fulfilment_status === 'Preparing').length > 0) ? (
              // <div>
              <SubmitBatchButton
                color="danger"
                title="Submit Batch"
                task={() => this.submitShipmentBatch(row.original)}
              />
              //   <br />
              //   <SubmitBatchButton
              //     color="danger"
              //     title="Submit DHL"
              //     task={() => this.submitShipmentBatch(row.original)}
              //   />
              // </div>
          ) :
              // <div>
              <Button
                color="primary"
                size="sm"
                onClick={() => this.generateOrderPDF(row.original)}
              >Generate Batch
              </Button>
              //   <br />
              //   // <Button
              //   //   color="primary"
              //   //   size="sm"
              //   //   onClick={() => this.generateOrderPDF(row.original)}
              //   // >Generate DHL
              //   // </Button>
              // </div>
               }
          </div>
        ),
      },
    ];

    return (
      <Col>
        <Card>
          <CardBody>
            <PDFDownloadLink
              className="btn btn-primary"
              document={MyDoc}
              fileName="ABDPullSheet.pdf"
            >
              {({
              loading,
            }) => (loading ? 'Loading document...' : 'Download')}
            </PDFDownloadLink>
            <ReactTable
              data={this.state.groupedData}
              columns={groupedColumns}
              showPagination={false}
              className="-striped -highlight -responsive"
              filterable
              defaultPageSize={200}
              defaultFiltered={[
                {
                  id: 'order_type',
                  value: 'Ready',
                },
              ]}
              getTrProps={(state, rowInfo) => {
                if (rowInfo !== undefined) {
                  return {
                  onClick: (e) => {
                  this.setState({
                  selectedGroup: rowInfo.original,
                  data: rowInfo.original.orders,
                });
                    },
                    style: {
                    background: rowInfo.original === this.state.selectedGroup ? '#00afec' : 'white',
                    color: rowInfo.original === this.state.selectedGroup ? 'white' : 'black',
                  },
                };
              }
              return {};
              }}
              style={{
                height: '400px',
              }}
            />
            <ReactTable
              style={{
                height: '400px',
              }}
              data={this.state.data} // should default to []
              columns={ordersColumns}
              pages={this.state.pages} // should default to -1 (which means we don't know how many pages we have)
              loading={this.state.loading}
              manual
              filterable
              multiSort={false}
              defaultPageSize={250}
              defaultSorted={[
                {
                  id: 'order_date',
                  desc: true,
                },
              ]}
              className="-striped -highlight -responsive"
              getTrProps={(state, rowInfo) => {
                  if (rowInfo !== undefined) {
                    return {
                      onClick: () => {
                        const currentShipment = this.state.shipmentBatch.find(shipment =>
                          shipment.fulfillmentId === rowInfo.original.id);

                        this.setState({
                          selected: rowInfo.original,
                          selectedActWeight: currentShipment ? currentShipment.weight : '',
                          // selectedSize: currentShipment ? currentShipment.actual_size : rowInfo.original.package_size,
                          selectedMMPrice: currentShipment ? currentShipment.mm_shipping_cost : 0,
                          selectedActualPrice: currentShipment ? currentShipment.actual_shipping_price : 0,
                        });
                        console.log(rowInfo.original);
                      },
                      style: {
                        background: rowInfo.original === this.state.selected ? '#00afec' : 'white',
                        color: rowInfo.original === this.state.selected ? 'white' : 'black',
                      },
                    };
                  }
                    return {};
                }} // informs React Table that you'll be handling sorting and pagination server-side
            />
          </CardBody>
        </Card>
        {this.state.selected !== undefined ? (
          <CardDeck>
            <Card>
              <CardBody>
                <div className="project-summary">
                  <div className="card__title">
                    <h5 className="bold-text">{`${this.state.selected.external_order_id}`}</h5>
                  </div>
                  <div className="project-summary__stats">
                    <div className="project-summary__stat">
                      <table className="project-summary__info">
                        <tbody>
                          <tr>
                            <th>Order date:</th>
                            <td>{new Date(this.state.selected.created_date).toLocaleDateString()}</td>
                          </tr>
                          <tr>
                            <th>Order Status:</th>
                            <td>{this.state.selected.status}</td>
                          </tr>
                          <tr>
                            <th>Buyer Notes:</th>
                            <td><b>{this.state.selected.buyer_notes}</b></td>
                          </tr>
                          <tr>
                            <th>Ship Notes:</th>
                            <td><b>{this.state.selected.ship_notes}</b></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="project-summary__stat">
                      <table className="project-summary__info">
                        <tbody>
                          <tr>
                            <th>Service:</th>
                            {/* <td>{this.getServiceLabel(
                              this.state.selected.shipping_service,
                              this.state.selected.shipping_address_country_code,
                            )}
                            </td> */}
                          </tr>
                          <tr>
                            <th>Weight (est.):</th>
                            <td>{this.state.selected.estimated_weight}g</td>
                          </tr>
                          <tr>
                            <th>Price (est.):</th>
                            <td>{currencyFormat.format(this.state.selected.estimated_shipping_price)}</td>
                          </tr>
                          <tr>
                            <th>Weight (act.):</th>
                            <td>
                              <input
                                type="number"
                                name="actual_weight"
                                value={this.state.selectedActWeight}
                                onChange={this.handleWeightChange}
                                min={1}
                                max={1999}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Size</th>
                            {/* <td>
                              <select
                                onChange={event => this.handleSizeChange(event.target.value)}
                                value={this.state.selectedSize}
                                disabled={!this.isDomestic(this.state.selected.shipping_address_country_code)}
                              >
                                <option value="LL">Large Letter</option>
                                <option value="SP">Small Parcel</option>
                              // </select>
                            </td> */}
                          </tr>
                          <tr>
                            <th>Price (act.):</th>
                            <td>{currencyFormat.format(this.state.selectedActualPrice)}</td>
                          </tr>
                          <tr>
                            <th>MM Cost:</th>
                            <td>{currencyFormat.format(this.state.selectedMMPrice)}</td>
                          </tr>
                          <tr>
                            <th />
                            <td>
                              <button
                                className="btn btn-primary"
                                type="button"
                                disabled={!this.state.selectedActWeight}
                                onClick={this.state.shipmentBatch.find(shipment =>
                                  shipment.fulfillmentId === this.state.selected.id)
                                  ? this.removeFromShipmentBatch : this.addToShipmentBatch}
                              >{this.state.shipmentBatch.find(shipment =>
                                shipment.fulfillmentId === this.state.selected.id)
                                ? 'Remove From Batch' : 'Add To Batch'}
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="project-summary__stat">
                      <table className="project-summary__info">
                        <tbody>
                          {/* <tr>
                            <th>Shipping Address:</th>
                            <td>{this.getShippingAddress()}</td>
                          </tr> */}
                          <tr>
                            <th>First Name:</th>
                            {this.state.isEditing ? (
                              <td>
                                <input
                                  type="text"
                                  name="shipping_address_firstname"
                                  value={this.state.selected.shipping_address_firstname}
                                  // onChange={this.handleWeightChange}
                                  // min={1}
                                  // max={1999}
                                />
                              </td>
                            ) : <td>{this.state.selected.shipping_address_firstname}</td> }
                          </tr>
                          <tr>
                            <th>Last Name:</th>
                            <td>{this.state.selected.shipping_address_lastname}</td>
                          </tr>
                          <tr>
                            <th>Address 1:</th>
                            <td>{this.state.selected.shipping_address_1}</td>
                          </tr>
                          {this.state.selected.shipping_address_2 ? (
                            <tr>
                              <th>Address 2:</th>
                              <td>{this.state.selected.shipping_address_2}</td>
                            </tr>
                          ) : null }
                          {this.state.selected.shipping_address_3 ? (
                            <tr>
                              <th>Address 3:</th>
                              <td>{this.state.selected.shipping_address_3}</td>
                            </tr>
                          ) : null }
                          <tr>
                            <th>City:</th>
                            <td>{this.state.selected.shipping_address_city}</td>
                          </tr>
                          {this.state.selected.shipping_address_region ? (
                            <tr>
                              <th>County:</th>
                              <td>{this.state.selected.shipping_address_region}</td>
                            </tr>
                          ) : null }
                          <tr>
                            <th>Postcode:</th>
                            <td>{this.state.selected.shipping_address_postcode}</td>
                          </tr>
                          {/* <tr>
                            <th>Country:</th>
                            <td>{this.getCountryLabel(this.state.selected.shipping_address_country_code)}</td>
                          </tr> */}
                          <Button
                            color="primary"
                            size="sm"
                            onClick={() => this.copyShippingAddressToClipboard()}
                          >Copy Address
                          </Button>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <hr />
                </div>
                <SubmitBatchButton
                  color="primary"
                  title={`Submit Batch (${this.state.shipmentBatch.length})`}
                  task={() => this.submitShipmentBatch()}
                />
              </CardBody>
            </Card>
          </CardDeck>) : null }
      </Col>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
});

// export default connect()(SidebarContent);
export default connect(mapStateToProps)(OpenOrdersTable);
